export default "__VITE_ASSET__22f37e9f__"